import { render, staticRenderFns } from "./OverviewAlignmentCard.vue?vue&type=template&id=42c3793c"
import script from "./OverviewAlignmentCard.vue?vue&type=script&lang=js"
export * from "./OverviewAlignmentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports